// extracted by mini-css-extract-plugin
export default {"fullWidth":"Wn-z","image":"Xn-z","lazyLoadPicture":"Yn-z","lazyLoadSpinner":"Zn-z","lazyLoadSpin":"_n-z","lazyLoadImage":"ao-z","hasStyledAspectRatio":"bo-z"};